module.exports = __webpack_public_path__ + "static/social-media-h264-ac7d9b85624f99506457ab8292f45667.mp4";